import type * as React from 'react';
import { cn } from './lib/cn';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  ref?: React.Ref<HTMLSelectElement>;
}

/** Select nativo com a mesma aparencia do Input. */
export function Select({ className, ref, children, ...props }: SelectProps) {
  return (
    <select
      ref={ref}
      className={cn(
        'flex w-full rounded-md border border-input bg-muted/50 transition-colors placeholder:text-muted-foreground hover:bg-muted focus-visible:border-primary focus-visible:bg-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-50',
        'h-11 px-3 py-1 text-base sm:h-9 sm:text-sm',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}
